module.exports = {"360983001":"瑞州街道","360983002":"筠阳街道","360983100":"蓝坊镇","360983101":"荷岭镇","360983102":"黄沙岗镇","360983103":"新街镇","360983104":"八景镇","360983105":"独城镇","360983106":"太阳镇","360983107":"建山镇","360983108":"田南镇","360983109":"相城镇","360983110":"灰埠镇","360983111":"石脑镇","360983112":"龙潭镇","360983113":"杨圩镇","360983114":"村前镇","360983115":"伍桥镇","360983116":"祥符镇","360983117":"大城镇","360983118":"华林山镇","360983200":"上湖乡","360983201":"汪家圩乡","360983400":"高安市新世纪工业城管委会","360983403":"英岗岭矿务局","360983404":"江西八景煤矿有限公司","360983405":"江西新茂实业公司","360983500":"相城垦殖场","360983501":"上游水库工程管理局","360983502":"江西省瑞州监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360983.json
// module id = 1226
// module chunks = 0